import { motion } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];

export const MaskedLines = ({ lines, className = "", delay = 0.15 }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);
